// extracted by mini-css-extract-plugin
module.exports = {"section":"Summary_section__2Pup9","page-navigation":"Summary_page-navigation__3N9FX"};